import { render, staticRenderFns } from "./viewAttachment.vue?vue&type=template&id=7137b9f2&"
import script from "./viewAttachment.vue?vue&type=script&lang=js&"
export * from "./viewAttachment.vue?vue&type=script&lang=js&"
import style0 from "./viewAttachment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports